// extracted by mini-css-extract-plugin
export default {"root":"AutouploadTooltip__root--1dY0g","text":"AutouploadTooltip__text--3H_Cp","link":"AutouploadTooltip__link--EOgNS"};